import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import VizsgaTableService from '../service/VizsgaTableService';

const config = {
	key: 'vizsgaTable',
	text: 'Vizsga',
	textKey: 'vizsga',
	service: VizsgaTableService,
	editFormState: item => `/vizsga/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'search', 'refresh', 'new'],
	filterFields: [
		{
			text: 'Leírás',
			propertyName: 'leiras',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['exportData', 'modify', 'delete'],
	exportData: {
		tooltip: 'XLS Export',
		link: item => `${nBossConnection.basePath}vizsgaControl/createXLSX?examId=${item.id}`
	},
	rowButtonList: [
		{
			text: 'DOCX Export',
			icon: 'insert_drive_file',
			action: item => window.open(`${nBossConnection.basePath}vizsgaControl/createExamQuestionDOC?examId=${item.id}`, '_blank', '')
		},
		{
			text: 'Vizsga csomag papíros',
			icon: 'insert_drive_file',
			action: item => window.open(`${nBossConnection.basePath}vizsgaControl/createExamPack?group=&examId=${item.id}&eType=paper`, '_blank', '')
		},
		{
			text: 'Vizsga csomag online',
			icon: 'insert_drive_file',
			action: item => window.open(`${nBossConnection.basePath}vizsgaControl/createExamPack?group=&examId=${item.id}&eType=online`, '_blank', '')
		},
		{
			text: 'Vizsga csomag tükör',
			icon: 'insert_drive_file',
			action: item => window.open(`${nBossConnection.basePath}vizsgaControl/createExamPack?group=&examId=${item.id}&eType=mirror`, '_blank', '')
		}
	],
	columns: [
		{
			key: 'name',
			text: 'Név',
			textKey: 'name',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'leiras',
			text: 'Leírás',
			textKey: 'leiras',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'datum',
			text: 'Dátum',
			textKey: 'datum',
			type: 'dateTime',
			sortable: true,
			disablePadding: false
		}
	]
};

function VizsgaTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('vizsgaTable', reducer('vizsgaTable'))(VizsgaTable);
